import React from "react";
import {
    useLocation,
    useNavigate,
    useParams,
    Location,
    NavigateFunction
} from "react-router-dom";

// Define the router props type
type RouterProps = {
    location: Location;
    navigate: NavigateFunction;
    params: Record<string, string | undefined>;
};

// Define a generic HOC function to wrap components with router props
function withRouter<T extends object>(Component: React.ComponentType<T & { router: RouterProps }>) {
    return function ComponentWithRouterProp(props: T) {
        const location = useLocation();
        const navigate = useNavigate();
        const params = useParams();

        return <Component {...props} router={{ location, navigate, params }} />;
    };
}

export default withRouter;
